import { Helmet } from "react-helmet-async";
import { useLanguage } from "../i18n/LanguageContext";

const SITE_URL = "https://www.deo.co.il";
const SITE_NAME = "M'art - דאודורנט טבעי";
const LOGO_URL = "/icons/mart-logo-full.jpg";

// Keywords for SEO
const KEYWORDS = {
  he: "דאודורנט טבעי, דאודורנט להכנה עצמית, דאודורנט ביתי, דאודורנט ללא אלומיניום, דאודורנט אורגני, דאודורנט טבעי לנשים, דאודורנט טבעי לגברים, מתכון דאודורנט, הכנת דאודורנט בבית, דאודורנט ללא כימיקלים, דאודורנט ללא פרבנים, קוסמטיקה טבעית, DIY דאודורנט, דאודורנט עם שמנים אתריים, דאודורנט קוקוס, דאודורנט שיאה, deo, דאו, דיאודורנט",
  en: "natural deodorant, DIY deodorant, homemade deodorant, aluminum-free deodorant, organic deodorant, deodorant recipe, make deodorant at home, chemical-free deodorant, paraben-free deodorant, natural cosmetics, essential oil deodorant, coconut deodorant, shea butter deodorant"
};

const SEO_DATA = {
  home: {
    he: {
      title: "M'art - דאודורנט טבעי | מתכון חינם להכנה עצמית | ללא אלומיניום",
      description: "דאודורנט טבעי עם פורמולה פתוחה וחינמית. למדו להכין דאודורנט ביתי ללא אלומיניום, ללא פרבנים וללא כימיקלים. מתכון מלא + מחשבון חומרים + אפשרות לרכוש מוכן.",
      path: "/"
    },
    en: {
      title: "M'art - Natural Deodorant | Free DIY Recipe | Aluminum-Free",
      description: "Natural deodorant with open and free formula. Learn to make homemade deodorant without aluminum, parabens or chemicals. Full recipe + ingredient calculator + option to buy ready-made.",
      path: "/"
    }
  },
  about: {
    he: {
      title: "אודות MART - יוזמה לקוסמטיקה טבעית | ללא מטרות רווח",
      description: "MART היא יוזמה עצמאית שהוקמה בשנת 2024, ללא מטרות רווח. הנגשת ידע, חינוך הקהילה ויצירת שיח פתוח סביב פיתוח קוסמטיקה טבעית איכותית.",
      path: "/about"
    },
    en: {
      title: "About MART - Natural Cosmetics Initiative | Non-Profit",
      description: "MART is an independent initiative founded in 2024, non-profit. Knowledge accessibility, community education, and open dialogue around quality natural cosmetics development.",
      path: "/about"
    }
  },
  method: {
    he: {
      title: "השיטה - איך מכינים דאודורנט טבעי | M'art",
      description: "הכירו את השיטה המדעית להכנת דאודורנט טבעי יעיל. פורמולציה מבוססת מחקר עם חומרים טבעיים איכותיים: שמן קוקוס, חמאת שיאה, סודה לשתייה ושמנים אתריים.",
      path: "/method"
    },
    en: {
      title: "The Method - How to Make Natural Deodorant | M'art",
      description: "Learn the scientific method for making effective natural deodorant. Research-based formulation with quality natural ingredients: coconut oil, shea butter, baking soda and essential oils.",
      path: "/method"
    }
  },
  diy: {
    he: {
      title: "מדריך הכנת דאודורנט טבעי בבית | מתכון מלא חינם | M'art",
      description: "מדריך מלא ומפורט להכנת דאודורנט טבעי בבית. רשימת חומרים מדויקת, פרופורציות, שלבי הכנה וטיפים מקצועיים. הכינו דאודורנט ללא אלומיניום בעצמכם!",
      path: "/diy"
    },
    en: {
      title: "DIY Natural Deodorant Guide | Free Complete Recipe | M'art",
      description: "Complete detailed guide for making natural deodorant at home. Exact ingredient list, proportions, preparation steps and professional tips. Make aluminum-free deodorant yourself!",
      path: "/diy"
    }
  },
  product: {
    he: {
      title: "דאודורנט טבעי מוכן לרכישה | 50 מ״ל | M'art",
      description: "רכשו דאודורנט טבעי מוכן לשימוש. 50 מ״ל בצנצנת זכוכית ענברית + כפית עץ. אותה פורמולה פתוחה, ללא אלומיניום, ללא פרבנים. משלוח לכל הארץ.",
      path: "/product"
    },
    en: {
      title: "Ready-Made Natural Deodorant | 50ml | M'art",
      description: "Buy ready-to-use natural deodorant. 50ml in amber glass jar + wooden spoon. Same open formula, no aluminum, no parabens. Nationwide delivery.",
      path: "/product"
    }
  },
  community: {
    he: {
      title: "קהילת דאודורנט טבעי | שיתוף ניסויים וחוויות | M'art",
      description: "הצטרפו לקהילת M'art - מעבדה משותפת לחובבי דאודורנט טבעי והכנה עצמית. שתפו את הניסויים שלכם, קבלו טיפים ולמדו מחוויות של אחרים.",
      path: "/community"
    },
    en: {
      title: "Natural Deodorant Community | Share Experiments | M'art",
      description: "Join the M'art community - shared lab for natural deodorant and DIY enthusiasts. Share your experiments, get tips and learn from others' experiences.",
      path: "/community"
    }
  },
  whyOpen: {
    he: {
      title: "הקוד הפתוח - למה המתכון חינם | M'art דאודורנט טבעי",
      description: "למה אנחנו נותנים את מתכון הדאודורנט הטבעי בחינם? כי ידע צריך להיות נגיש לכולם. קראו על הפילוסופיה שלנו ועל קוסמטיקה מודעת.",
      path: "/why-open"
    },
    en: {
      title: "Open Source - Why the Recipe is Free | M'art Natural Deodorant",
      description: "Why do we give the natural deodorant recipe for free? Because knowledge should be accessible to everyone. Read about our philosophy and conscious cosmetics.",
      path: "/why-open"
    }
  },
  editorial: {
    he: {
      title: "מאמר על דאודורנט טבעי וקוסמטיקה מודעת | M'art",
      description: "מאמר מקיף על דאודורנט טבעי, הבעיות עם דאודורנטים מסחריים, יתרונות הכנה עצמית וטיפים לבחירת חומרים איכותיים לקוסמטיקה טבעית.",
      path: "/editorial"
    },
    en: {
      title: "Article on Natural Deodorant and Conscious Cosmetics | M'art",
      description: "Comprehensive article about natural deodorant, problems with commercial deodorants, benefits of DIY and tips for choosing quality ingredients for natural cosmetics.",
      path: "/editorial"
    }
  },
  articles: {
    he: {
      title: "מאמרים על דאודורנט טבעי וקוסמטיקה מודעת | M'art",
      description: "מאמרים מקיפים על דאודורנט טבעי, המדע שמאחורי הרכיבים הטבעיים, סודיום ביקרבונט וקוסמטיקה מודעת. ידע פתוח לכולם.",
      path: "/articles"
    },
    en: {
      title: "Articles on Natural Deodorant and Conscious Cosmetics | M'art",
      description: "Comprehensive articles about natural deodorant, the science behind natural ingredients, sodium bicarbonate and conscious cosmetics. Open knowledge for everyone.",
      path: "/articles"
    }
  },
  "article-sodium-bicarbonate": {
    he: {
      title: "סודיום ביקרבונט: המדע שמאחורי נטרול ריח גוף באופן טבעי | M'art",
      description: "מאמר מדעי על סודיום ביקרבונט כחומר פעיל בדאודורנט טבעי. מנגנון פעולה, איכות חומר גלם, השפעות פסיכולוגיות ושאלות נפוצות.",
      path: "/articles/sodium-bicarbonate"
    },
    en: {
      title: "Sodium Bicarbonate: The Science Behind Natural Body Odor Neutralization | M'art",
      description: "Scientific article about sodium bicarbonate as an active ingredient in natural deodorant. Mechanism of action, raw material quality, psychological effects and FAQ.",
      path: "/articles/sodium-bicarbonate"
    }
  },
  calculator: {
    he: {
      title: "מחשבון חומרים לדאודורנט טבעי | חשבו כמויות בקלות | M'art",
      description: "מחשבון אינטראקטיבי לחישוב כמויות החומרים לדאודורנט טבעי. בחרו כמות סופית רצויה או חשבו לפי החומרים שיש לכם בבית. תוצאות בגרם ובכפיות.",
      path: "/calculator"
    },
    en: {
      title: "Natural Deodorant Calculator | Easy Ingredient Amounts | M'art",
      description: "Interactive calculator for natural deodorant ingredients. Choose desired final amount or calculate based on ingredients you have at home. Results in grams and teaspoons.",
      path: "/calculator"
    }
  },
  terms: {
    he: {
      title: "תקנון ואחריות | M'art דאודורנט טבעי",
      description: "תקנון השימוש באתר M'art ובמוצרי הדאודורנט הטבעי. אזהרות חשובות, הגבלת אחריות, הנחיות בטיחות ומידע על בדיקת רגישות.",
      path: "/terms"
    },
    en: {
      title: "Terms & Disclaimer | M'art Natural Deodorant",
      description: "Terms of use for M'art website and natural deodorant products. Important warnings, liability limitations, safety guidelines and patch test information.",
      path: "/terms"
    }
  }
};

// Structured Data for Organization
const getOrganizationSchema = () => ({
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": "M'art",
  "alternateName": "M'ART דאודורנט טבעי",
  "url": SITE_URL,
  "logo": LOGO_URL,
  "description": "דאודורנט טבעי עם פורמולה פתוחה. הכנה עצמית או רכישה מוכנה.",
  "sameAs": []
});

// Structured Data for Product
const getProductSchema = (language) => ({
  "@context": "https://schema.org",
  "@type": "Product",
  "name": language === 'he' ? "דאודורנט טבעי M'art" : "M'art Natural Deodorant",
  "description": language === 'he' 
    ? "דאודורנט טבעי ללא אלומיניום, ללא פרבנים וללא כימיקלים. 50 מ״ל בצנצנת זכוכית ענברית."
    : "Natural deodorant without aluminum, parabens or chemicals. 50ml in amber glass jar.",
  "brand": {
    "@type": "Brand",
    "name": "M'art"
  },
  "offers": {
    "@type": "Offer",
    "price": "50",
    "priceCurrency": "ILS",
    "availability": "https://schema.org/InStock",
    "url": `${SITE_URL}/product`
  },
  "image": LOGO_URL
});

// Structured Data for HowTo (DIY page)
const getHowToSchema = (language) => ({
  "@context": "https://schema.org",
  "@type": "HowTo",
  "name": language === 'he' ? "איך להכין דאודורנט טבעי בבית" : "How to Make Natural Deodorant at Home",
  "description": language === 'he'
    ? "מדריך מלא להכנת דאודורנט טבעי ללא אלומיניום בבית"
    : "Complete guide for making aluminum-free natural deodorant at home",
  "totalTime": "PT30M",
  "supply": [
    { "@type": "HowToSupply", "name": language === 'he' ? "שמן קוקוס" : "Coconut oil" },
    { "@type": "HowToSupply", "name": language === 'he' ? "חמאת שיאה" : "Shea butter" },
    { "@type": "HowToSupply", "name": language === 'he' ? "עמילן תירס" : "Cornstarch" },
    { "@type": "HowToSupply", "name": language === 'he' ? "סודה לשתייה" : "Baking soda" },
    { "@type": "HowToSupply", "name": language === 'he' ? "שמנים אתריים" : "Essential oils" }
  ],
  "step": [
    {
      "@type": "HowToStep",
      "name": language === 'he' ? "המסה" : "Melting",
      "text": language === 'he' ? "המיסו את שמן הקוקוס וחמאת השיאה בבן מארי" : "Melt coconut oil and shea butter in a double boiler"
    },
    {
      "@type": "HowToStep", 
      "name": language === 'he' ? "ערבוב" : "Mixing",
      "text": language === 'he' ? "הוסיפו את העמילן והסודה וערבבו היטב" : "Add cornstarch and baking soda, mix well"
    },
    {
      "@type": "HowToStep",
      "name": language === 'he' ? "ניחוח" : "Scenting",
      "text": language === 'he' ? "הוסיפו שמנים אתריים לפי בחירה" : "Add essential oils of your choice"
    }
  ]
});

// Structured Data for WebSite with SearchAction
const getWebSiteSchema = () => ({
  "@context": "https://schema.org",
  "@type": "WebSite",
  "name": SITE_NAME,
  "alternateName": ["M'ART", "M'art", "Mart Deodorant", "דאודורנט M'ART"],
  "url": SITE_URL,
  "description": "דאודורנט טבעי עם פורמולה פתוחה להכנה עצמית או רכישה מוכנה",
  "inLanguage": ["he-IL", "en"],
  "potentialAction": {
    "@type": "SearchAction",
    "target": `${SITE_URL}/?q={search_term_string}`,
    "query-input": "required name=search_term_string"
  }
});

// Structured Data for LocalBusiness
const getLocalBusinessSchema = () => ({
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "name": "M'art - דאודורנט טבעי",
  "@id": SITE_URL,
  "url": SITE_URL,
  "image": LOGO_URL,
  "description": "ייצור ומכירת דאודורנט טבעי. מתכון פתוח להכנה עצמית.",
  "address": {
    "@type": "PostalAddress",
    "addressCountry": "IL"
  },
  "priceRange": "₪₪"
});

export const SEO = ({ page }) => {
  const { language } = useLanguage();
  const data = SEO_DATA[page]?.[language] || SEO_DATA.home[language];
  const isRTL = language === 'he';
  const canonicalUrl = `${SITE_URL}${data.path}`;

  // Build structured data array based on page
  const structuredData = [getOrganizationSchema(), getWebSiteSchema()];
  
  if (page === 'product') {
    structuredData.push(getProductSchema(language));
  }
  if (page === 'diy') {
    structuredData.push(getHowToSchema(language));
  }
  if (page === 'home') {
    structuredData.push(getLocalBusinessSchema());
  }

  return (
    <Helmet defer={false}>
      <html lang={language} dir={isRTL ? 'rtl' : 'ltr'} />
      <title>{data.title}</title>
      <meta name="description" content={data.description} />
      <meta name="keywords" content={KEYWORDS[language]} />
      <link rel="canonical" href={canonicalUrl} />
      
      {/* Open Graph */}
      <meta property="og:title" content={data.title} />
      <meta property="og:description" content={data.description} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:locale" content={isRTL ? 'he_IL' : 'en_US'} />
      <meta property="og:image" content={LOGO_URL} />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={data.title} />
      <meta name="twitter:description" content={data.description} />
      <meta name="twitter:image" content={LOGO_URL} />
      
      {/* Additional SEO tags */}
      <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
      <meta name="googlebot" content="index, follow" />
      <meta name="author" content="M'art" />
      <meta name="geo.region" content="IL" />
      <meta name="geo.placename" content="Israel" />
      <meta name="language" content={language === 'he' ? 'Hebrew' : 'English'} />
      
      {/* Structured Data */}
      {structuredData.map((schema, index) => (
        <script key={index} type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      ))}
    </Helmet>
  );
};

export default SEO;
